import autoTable from "jspdf-autotable";

import { format } from "crypto-js";
import { PDF_TABLE_STYLE,PDFCOLORSHEME } from "../../../../../../component/constent";

export function drawShopTable(doc, shop, rows, total) {
  let startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 20
    : 28;

  function format(value) {
    return Number(value || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }



  const columnStyles = {
    0: { cellWidth: 40, halign: "left" },
    1: { cellWidth: 35, halign: "right" },
    2: { cellWidth: 35, halign: "right" },
    3: { cellWidth: 35, halign: "right" },
    4: { cellWidth: 35, halign: "right" },
    

  };

  const pageHeight = doc.internal.pageSize.getHeight();

  if (startY > pageHeight - 25) {
    doc.addPage();
    startY = 28;
  }

  // ================= HEADER =================
  // doc.setFillColor(52, 100, 160);
  // doc.rect(14, startY - 10, 190, 8, "F");

  // doc.setTextColor(255);
  // doc.setFont("helvetica", "bold");
  // doc.setFontSize(10);
  //doc.text(` ${shop} Railway`, 20, startY - 5);

  // ================= DETAIL TABLE =================
  autoTable(doc, {
    startY,
...PDF_TABLE_STYLE,
    head: [[

      "Department",
      "U/O Charge Labour on Cost (A)",
      "Diff. Between Time Sheet & Master Sheet (B)",
      "Total of A+B",
      "U/O Charge Store on Cost ",
     

    ]],



    body: rows.map((r) => [
      (r["DIVISIONTYPE"]),
      format(r["U/O CHARGE LABOUR ON COST (A)"]),
      format(r["ENGA - TIMESHEET(B)"]),
      format(r["TOTAL OF A+B"]),
      format(r["U/O ON COST STORE"]),
      
    ]),

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY,
      halign: "right",
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_HEADER,
      textColor: PDFCOLORSHEME.FONT_COLOR_HEADER,
      halign: "center",
      fontStyle: "bold",
    },

    columnStyles,
  });

  // ================= DEPOT TOTAL =================
  const y = doc.lastAutoTable.finalY + 2;

  doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_TOTAL);
  doc.rect(14, y, 180, 8, "F");

  doc.setTextColor(PDFCOLORSHEME.FONT_COLOR_TOTAL);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(PDFCOLORSHEME.FONT_SIZE_TOTAL);

  // Depot Total text
  doc.text(`TOTAL`, 30, y + 5);

  // Debit Total
  doc.text(format(total.DirectLabour), 88, y + 5, {
    align: "right",
  });

  // Credit Total
  doc.text(format(total.DirectStore), 120, y + 5, {
    align: "right",
  });

  // // Labour Cost Total
  //  doc.text(format(total.OnCostLabour), 158, y + 5, {
  //   align: "right",
  // });

// Labour Cost Total
   doc.text(format(total.OnCostStore), 190, y + 5, {
    align: "right",
  });



  // Reset text color
  doc.setTextColor(0);

  // Reserve space after Depot Total
  doc.lastAutoTable.finalY = y + 5;
  //                 rectangle height ^   ^ extra space
}



